<template>
  <div class="app-footer">
    <div v-if="isAdsDashboard" class="ads-tnc-footer">
      <a
        href="https://tamara.co/docs/Ads_Terms&Conditions.pdf"
        target="_blank"
        class="footer-link"
      >
        {{ $t('ads_terms_conditions') }}
      </a>
      <a
        href="https://tamara.co/docs/Ads_Promotion_Terms.pdf"
        target="_blank"
        class="footer-link"
      >
        {{ $t('ads_promotion_terms') }}
      </a>
    </div>

    <AdsTermAndConditionModal
      :visible="tncVisible"
      :loading="loading"
      @cancel="onCancelTNC"
      @confirm="onConfirmTNC"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AdsTermAndConditionModal from '@/views/ads/components/AdsTermAndConditionModal.vue'
import { submitAcceptTermAndCondition } from '@/api/ads'

export default {
  name: 'AppFooter',
  components: {
    AdsTermAndConditionModal,
  },
  data() {
    return {
      loading: false,
      tncVisible: false,
    }
  },
  computed: {
    ...mapState('ads', ['advertiser']),
    isAdsDashboard() {
      return this.$route.path.includes('/ads/dashboard')
    },
  },
  watch: {
    '$route.path': {
      handler(val) {
        // If advertiser not exists, should be the case of user didn't initialize Adtech yet
        // and will be automatically redirect back to dashboard
        if (!this.advertiser) {
          return
        }

        // Only show T&C for existing user that didn't accept T&C yet,
        // And should show only in Adtech, since not all merchant are using AdTech module
        const isInAdsRoute = val.startsWith('/ads')
        const isSubmittedTnc = this.advertiser.isSubmittedTnc
        if (isInAdsRoute && !isSubmittedTnc) {
          this.tncVisible = true
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions('ads', ['fetchAdvertiser']),
    onCancelTNC() {
      this.fetchAdvertiser()

      this.$router.push('/dashboard/home')
      this.tncVisible = false
    },
    async onConfirmTNC() {
      this.loading = true

      try {
        await submitAcceptTermAndCondition()
      } catch {
        // If submit error => chances are due to other user from the same merchant
        // accepted previously
      }

      try {
        // Re-fetch advertiser to update confirmed T&C flag
        const advertiser = await this.fetchAdvertiser()

        if (advertiser.isSubmittedTnc) {
          this.tncVisible = false
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.app-footer {
  padding-block: 0;
  padding-inline: 40px;

  .footer-link {
    @apply underline text-sm;
  }
}

.ads-tnc-footer {
  @apply flex gap-8 h-full -mt-24;
}
</style>
